import React from "react";
import "./About.css";
import MinimalNavbar from "./MinimalNavbar";
import "./styles/backgrounds.css";

const About = () => {
  return (
    <>
      <div className="navbar-container">
        <MinimalNavbar />
      </div>
<div className="page-background other-background">


        <div className="about-bloc">
          <h1 className="about-title">À PROPOS</h1>
          <p className="about-subtext">
            Bienvenue sur Mon Prochain Livre !  
          </p>
          <p className="about-subtext">
            Ici, notre mission est simple : vous aider à dénicher le livre qui fera vibrer votre curiosité, 
            parler à vos émotions ou même transformer votre quotidien.  
          </p>
          <p className="about-subtext">
            Comment ça marche ? Rien de plus facile : répondez à quelques questions rapides et 
            laissez notre questionnaire interactif vous guider vers une sélection sur-mesure.  
            Chacune de nos recommandations est choisie avec soin pour qu’elle vous corresponde 
            vraiment. 
          </p>
          <p className="about-subtext">
            Que vous ayez envie de plonger dans le développement personnel, de booster vos 
            compétences, de vous offrir une belle évasion ou simplement de trouver un peu de 
            réconfort, vous trouverez ici un compagnon de lecture qui vous ressemble.  
          </p>
          <p className="about-subtext">
            Et parce que la lecture est encore plus belle quand elle se partage, vous pouvez aussi nous 
            confier le livre qui a changé quelque chose pour vous. Rendez-vous sur la page “Partage” pour nous confier votre coup de coeur qui pourrait 
            inspirer et aider d’autres lecteurs à leur tour ! 
          </p>
        </div>
      </div>
    </>
  );
};

export default About;
